import React from "react";

const LandItemSkeleton: React.FC = () => {
  return (
    <div
      data-testid="land-item-skeleton"
      className="w-full h-auto overflow-hidden rounded-[6px] bg-gray-50 shadow"
    >
      {/* Image container skeleton */}
      <div
        data-testid="skeleton-image"
        className="relative w-full h-[334px] bg-gray-200 animate-pulse"
      ></div>

      {/* Content section */}
      <div data-testid="skeleton-content" className="p-4">
        {/* Price skeleton */}
        <div
          data-testid="skeleton-item-price"
          className="h-5 w-28 bg-gray-200 rounded animate-pulse"
        ></div>

        {/* Title skeleton */}
        <div
          data-testid="skeleton-item-title"
          className="pt-2 h-7 w-full bg-gray-200 rounded animate-pulse mt-2"
        ></div>

        {/* Area with icon skeleton */}
        <div className="flex items-center mt-3">
          <div
            data-testid="skeleton-item-icon"
            className="w-5 h-5 bg-gray-200 rounded-full mr-2 animate-pulse"
          ></div>
          <div
            data-testid="skeleton-item-area"
            className="h-5 w-20 bg-gray-200 rounded animate-pulse"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LandItemSkeleton;
